import React, {useContext} from 'react'

import {LocationPuzzlesContext} from '../../context/LocationPuzzlesContext'
import BrassPanel from '../../components/BrassPanel'

function Inventory() {
    const {
        location,
        setInventorySceneText,
        updateSceneText,
        isItemCollected,
        isItemSelected, 
        setIsItemSelected
    } = useContext(LocationPuzzlesContext)
    
    const inventoryIndex = {
        office: {icon: "fas fa-key", text: "It's a key!"},
        library: {icon: 'fas fa-file-alt', text: 'A completed book request form.'},
        laboratory: {icon: 'fas fa-vial', text: 'A small vial of chemicals.'},
        fourJokers: {icon: 'fas fa-camera-retro', text: 'A camera.'},
        lastStand: {icon: 'fas fa-wrench', text: 'A sturdy wrench'},
        machine: {icon: '', text: ''}
    }
    
    const classString = isItemSelected ? 'inventory_box-clicked' : ''
    
    function changeSceneText() {
        const itemText = 
              `${inventoryIndex.[location].text} ${isItemSelected ? 'Choose somewhere to use it' : 'Click to select it'}`
        const textToShow = isItemCollected ? itemText : 'Your pockets are empty'
        updateSceneText(textToShow)
    }
    
    function handleClick() {
        if (isItemCollected) {
            const instruction = !isItemSelected ? 'Choose somewhere to use it' : 'Click to select it'
            const sceneText = `${inventoryIndex.[location].text} ${instruction}`
            updateSceneText(sceneText)
            !isItemSelected && setInventorySceneText(sceneText)
            setIsItemSelected(prevState => !prevState)
        }
    }
    
    return (
        <BrassPanel extraClasses="sideContainer sideContainer-inventory">
            <p>Inventory</p>
            <div 
                className={`inventory_box ${classString}`}
                onMouseEnter={changeSceneText}
                onMouseLeave={() => {!isItemSelected && updateSceneText()}}
                onClick={handleClick}
            >
                <i className={isItemCollected ? inventoryIndex.[location].icon : 'fas fa-times'}></i>
            </div>
        </BrassPanel>
    )
}

export default Inventory